import _ from 'lodash'
import Cookies from 'js-cookie'
import { createBrowserHistory } from 'history'
import { envs } from '../redux/api/windowServerData'

export const mockUrlEcommerceLogin =
    'https://lojaqas.germini.com.br/customer/account/login/referer/aHR0cHM6Ly9sb2phcWFzLmdlcm1pbmkuY29tLmJyLw~~/'

export const history = createBrowserHistory()
export { authHeader } from './auth-header'
export { configureFakeBackend } from './fake-backend'

export const isEcommerce = history.location.pathname.includes('ecommerce')

export const hideOnEcommerce = (children) => (isEcommerce ? null : children)

export const handleAuthCheck = () => {
    try {
        const publicPaths = new Set([
            '/auth/login',
            '/success',
            '/success/ecommerce',
            '/register/ecommerce',
            '/authenticateAccess/ecommerce',
            '/confirmRegistration/ecommerce',
            '/confirmToken',
            '/resetPassword',
            '/privacypolicies',
            '/resetpassword',
            '/confirmRegistration',
        ])

        const currentPath = history.location.pathname

        if (!publicPaths.has(currentPath)) {
            const isCvValeIdentity = envs.REACT_APP_CVALE_IDENTITY === 'true'
            if (!isCvValeIdentity) {
                const themeColor = Cookies.get('themeColor')
                const parsedTheme = themeColor ? JSON.parse(themeColor) : null

                if (_.isEmpty(parsedTheme)) {
                    handleAuthLogout()
                }
            }
        }
    } catch (error) {
        console.error('Auth check failed:', error)
        handleAuthLogout()
    }
}

export const handleAuthLogout = () => {
    localStorage.clear()
    Cookies.remove('themeColor')
    history.push('/auth/login')
}
